export default __webpack_public_path__ + "static/media/Footer_logo.231149e9.png";